///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                           RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import Tippy from "@tippyjs/react";

import FilterMenuContent from "./FilterMenuContent";
import FilterIcon from "../icons/FilterIcon";
import RangeFilter from "./RangeFilter";

function FilterMenu({
  id,
  options,
  field,
  disabled,
  handleFilter,
  show,
  hide,
  visible,
  rangeFilter,
  handleRangeFilter,
  showApplyButton = false,
  isSearchable = false,
  isLaneMatch,
  filterField,
  rangeFilterApplied,
  ...props
}) {
  const areFiltersApplied =
    options.some(x => x.selected === true) || rangeFilterApplied;
  const toggleFilterMenu = () => {
    if (visible !== undefined && visible === false) {
      show();
    } else {
      props.onClickOutside && props.onClickOutside();
    }
  };

  const handleFilterChange = (items, field) => {
    handleFilter(items, field);
    showApplyButton && props.onClickOutside && props.onClickOutside();
  };

  const content = rangeFilter ? (
    <RangeFilter
      handleFilter={(minValue, maxValue) => {
        handleRangeFilter({ minValue, maxValue }, field);
        props.onClickOutside();
      }}
      field={field}
      isLaneMatch={isLaneMatch}
    />
  ) : (
    <FilterMenuContent
      id={id}
      list={options}
      handleFilter={handleFilterChange}
      field={filterField ?? field}
      showApplyButton={showApplyButton}
      isSearchable={isSearchable}
    />
  );

  return (
    <Tippy
      visible={visible}
      arrow={false}
      className="bg-white filter-menu px-8 py-12"
      content={content}
      delay={0}
      disabled={disabled}
      duration={0}
      interactive
      placement="bottom-start"
      touch="hold"
      trigger={undefined}
      appendTo="parent"
      offset={[6, 3]}
      {...props}
    >
      <p
        onClick={toggleFilterMenu}
        onMouseUp={e => e.stopPropagation()}
        className={`inline pl-4 ${areFiltersApplied ? "" : "filter-region"} `}
      >
        <FilterIcon
          height="14px"
          width="14px"
          className={`fr ${disabled ? "" : "cursor-pointer"} filter-icon`}
          id={field}
          title=""
        />
      </p>
    </Tippy>
  );
}

export default FilterMenu;
